import React, { type FC } from "react";
import * as Styles from "./ServicesWithDetailsList.styles";
import FinanceService from "../extras/services/FinanceService";
import InsuranceService from "../extras/services/InsuranceService";
import { useUscSelector } from "../../../redux/store";
import { enableUscInsurance, enableUscMonthlyRate } from "../../../utils/settings";
import { useUscLabel } from "../../../utils/labels";

/**
 * Renders the services which can be configured by pressing the 'show/edit details' buttons
 * This is currently only used for finance and insurance
 */
const ServicesWithDetailsList: FC = () => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const uscSettings = useUscSelector((state) => state.uscSettings);

    const showFinance = enableUscMonthlyRate(commonSettings, uscSettings, vehicle.result, vehicle.type);
    const showInsurance = enableUscInsurance(commonSettings, uscSettings, vehicle.result, vehicle.type);
    const servicesWithDetails = showFinance || showInsurance;

    const ariaServicesTitleLabel = useUscLabel("uscA11yTabServices");

    if (!servicesWithDetails) return null;

    return (
        <Styles.ServicesList role="list" aria-label={ariaServicesTitleLabel}>
            {showFinance && (
                <Styles.ServiceListItem>
                    <FinanceService />
                </Styles.ServiceListItem>
            )}
            {showInsurance && (
                <Styles.ServiceListItem>
                    <InsuranceService />
                </Styles.ServiceListItem>
            )}
        </Styles.ServicesList>
    );
};

export default ServicesWithDetailsList;
